import apiClient from '../../services/apiClient';

export const DownloadFileReqAPI = {
 downloadPDF: async (id: string): Promise<void> => {
    try {
      const { data } = await apiClient.get(`/api/v2/movement/pdf/${id}`);
      const { url: fileUrl, filename = 'Comprobante_de_solicitud.pdf' } = data || {};

      if (!fileUrl) throw new Error('No se encontró la URL del documento.');

      const blob = await (await fetch(fileUrl)).blob();
      const downloadUrl = URL.createObjectURL(blob);

      const link = Object.assign(document.createElement('a'), {
        href: downloadUrl,
        download: filename,
      });

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      throw error;
    }
  },
};
